import { IGetState, TBoardId, TColorId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardUserMetaSetRecentColorTags = (
    boardId: TBoardId,
    recentColorTags: TColorId[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { recentColorTags }));
    };
    return action;
}
